import React from 'react';
import './LoginPage.css';

export default function LoginPage({ msalInstance }) {
  return (
    <div className="login-hero">
      <div className="hero-left">
        {/* watermark image placed from /public so webpack doesn't try to resolve it */}
        <img src="/logo192.png" alt="" aria-hidden="true" className="hero-watermark" />
        <div className="hero-eyebrow">Immigration Solution</div>
        <h1 className="hero-title">Classify immigration emails faster.</h1>
        <p className="hero-subtitle">Automated email classification, attachments preview, and case mapping so your intake team can focus on what matters.</p>

        <div className="hero-features">
          <div className="feature-pill">Automated classification</div>
          <div className="feature-pill">Attachment previews</div>
          <div className="feature-pill">IMS task mapping</div>
          <div className="feature-pill">MSAL SSO</div>
        </div>
      </div>

      <div className="hero-right">
        <div className="login-card">
          <img src="/logo.png" alt="IMS Logo" className="login-logo" />
          <div className="login-title">Sign in to the IMS Dashboard</div>
          <div className="login-sub">Enter your Microsoft account to continue</div>

          <button
            className="login-btn"
            onClick={() => msalInstance.loginRedirect()}
            title="Sign in with Microsoft"
            aria-label="Sign in with Microsoft"
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); msalInstance.loginRedirect(); } }}
          >
            Sign in with Microsoft
          </button>

          <div className="login-footer">Need help? Contact your administrator.</div>
        </div>
      </div>
    </div>
  );
}
